export default '/build/1baaa087.svg'